const variants = {
  login: "login",
  give: "give",
  signupList: "signupList",
  mmg: "mmg",
  famReg: "famReg",
};

const welcomeMessageComponentKeys = {
  withName: "withName",
  withoutName: "withoutName",
  withCustomText: "withCustomText",
};

const USE_LOGIN_PASSWORD = "USE_LOGIN_PASSWORD";
const LAST_EMAIL_PHONE = "lastEmailPhone";

export {
  variants,
  USE_LOGIN_PASSWORD,
  LAST_EMAIL_PHONE,
  welcomeMessageComponentKeys,
};
